import Trophy from "@/assets/svg/creator-shield/trophy.svg";
import Statistics from "@/components/creatorshield/Statistics";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function HeroSection() {
  const headlineRef = useScrollAnimation({ threshold: 0.2 });
  
  return (
    <div className="bg-white pt-36 pb-16 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        {/* Celebrating Success Badge */}
        <div className="flex justify-center mb-9 mt-[-11px]">
          <div className="flex items-center gap-2 border border-border rounded-full px-4 py-2">
            <img src={Trophy} alt="Telephone Icon" className="w-5 h-5" />
            <span className="font-normal text-black leading-normal whitespace-nowrap">Celebrating Success</span>
          </div>
        </div>

        {/* Main Headline */}
        <div ref={headlineRef} className="text-center space-y-6 mb-12 animate-fade-rise">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold leading-tight max-w-2xl mx-auto">
            <span className="text-[#34C759]">$50-Million</span> Claimed For{" "}
            <span className="text-[#FF6B35]">3,500+</span> Creators
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
            Real creators. Real results. Real money recovered from content
            theft.
          </p>
        </div>

        {/* Statistics */}
        <Statistics />
      </div>
    </div>
  );
}
